/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Add_Reactions_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to add new emoji reactions to a message. If this permission is disabled, members can still react using any existing reactions on a message." |
*
* @param {Leveling_Perm_Add_Reactions_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_add_reactions_hint = /** @type {((inputs?: Leveling_Perm_Add_Reactions_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Add_Reactions_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам добавлять к сообщениям новые реакции-эмодзи. Если право отключено, участники всё равно могут ставить реакции, которые уже есть под сообщением.")
	return /** @type {LocalizedString} */ ("Allows members to add new emoji reactions to a message. If this permission is disabled, members can still react using any existing reactions on a message.")
});